import { AspectRatio } from "@components/core/AspectRatio";
import DepthScroller from "@components/core/DepthScroller";

import { asset, config } from "./config";

export default function ProjectsHero() {
  const items = config.map(item => <Item key={item.name} {...item} />);
  return <DepthScroller asset={<Asset />} items={items} />;
}

function Item({ cover, author, name }: { author: string; cover: string; name: string }) {
  return (
    <div className='relative h-full w-[150px] overflow-hidden rounded-xl md:w-[250px] md:rounded-[32px] xxl:w-[350px]'>
      <AspectRatio ratio='1x1' rounded={false}>
        <img alt={`A cover of an audiobook by ${name}`} className='h-full w-full object-cover' src={cover} />
      </AspectRatio>
      <div className='absolute left-0 top-0 h-full w-full bg-gradient-to-b from-transparent to-[rgba(0,0,0,.4)]' />
      <div className='absolute bottom-6 left-6 flex items-center gap-4 rounded-full bg-default p-6 pe-12 md:bottom-10 md:bottom-16 md:left-10 md:left-16 md:gap-8 md:p-8 md:pe-16'>
        <img
          alt={`An avatar of ${name}`}
          className='h-16 w-16 rounded-full object-cover md:h-32 md:w-32'
          src={author}
        />
        <p className='f-ui-04 md:f-ui-03'>{name}</p>
      </div>
    </div>
  );
}

function Asset() {
  return (
    <div
      className='overflow-hidden rounded-md shadow-[0px_0px_32px_rgba(0,0,0,0.16)] backdrop-blur-md md:rounded-xl md:shadow-[0px_0px_48px_rgba(0,0,0,0.16)]'
      style={{ backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)" }}
    >
      <img
        alt='A screenshot of the ElevenLabs Projects UI'
        className='h-full w-full opacity-100 md:opacity-90'
        src={asset}
      />
    </div>
  );
}
